// http://stackoverflow.com/questions/13942279/knockoutjs-prevent-event-bubbling-for-elements-with-no-handler

import ko from "knockout";
import * as _ from "underscore";
import register from "flow/knockout/register";

register.registerKnockoutBinding("preventBubble", {
    init: function (element, valueAccessor) {
        const eventNameString = ko.utils.unwrapObservable(valueAccessor());
        const eventNames = eventNameString.split(" ");

        _.each(eventNames, function (eventName) {
            ko.utils.registerEventHandler(element, eventName, function (event: Event) {
                event.cancelBubble = true;
                if (event.stopPropagation) {
                    event.stopPropagation();
                }
            });
        });
    }
});
